import type { ReactNode } from 'react';

export const symbol_assistant_navigation: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Zm0-60q142 0 241-99.5T820-480q0-142-99-241t-241-99q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140Zm0-340ZM346-303l128-58q3-2 6-2t6 2l128 58q9 5 16.5-2.5T634-323L494-660q-4-9-14-9t-14 9L326-323q-4 10 3.5 17.5T346-303Z"
		/>
	</svg>
);
